import React from "react";
import { BaseDropdown } from "@components/library/UI";
import { ReactComponent as ArrowIcon } from "@assets/images/icons/arrow-down-icon.svg";

import "./FilterDropdown.sass";

export const FilterDropdown = ({
  value,
  options,
  onChange,
  hasSearch = false,
  className = "",
}) => {
  return (
    <BaseDropdown
      hasSearch={hasSearch}
      className={`filter-dropdown__compact-dropdown ${className}`}
      trigger={
        <button className="filter-dropdown__btn">
          {value} <ArrowIcon />
        </button>
      }
    >
      {({ closeDropdown, searchTerm }) => {
        const filteredOptions = options.filter((opt) =>
          opt.toLowerCase().includes((searchTerm || "").toLowerCase()),
        );

        return (
          <div className="filter-dropdown__menu" style={{ padding: 0 }}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
                <div
                  key={opt}
                  className="filter-dropdown__item"
                  onClick={() => {
                    onChange(opt);
                    closeDropdown();
                  }}
                >
                  {opt}
                </div>
              ))
            ) : (
              <div className="filter-dropdown__item" style={{ color: "#888" }}>
                No results found
              </div>
            )}
          </div>
        );
      }}
    </BaseDropdown>
  );
};
